<script lang="ts" setup>
import { theme as brandTheme } from '@/config/brands'

defineProps<{
  config: any
  records: any[]
  fetching: boolean
  ending: boolean
  page: number
  setInfiniteRef: (el: HTMLElement | null) => void
}>()

const pageBgColor = brandTheme.bgGlobal || '#14181F'
</script>

<template>
  <div :ref="setInfiniteRef" class="h-100dvh overflow-scroll" :style="{ background: pageBgColor }">
    <BasicNavbar class="color-n-text-2" />

    <div v-if="!fetching && page === 1 && records.length === 0" class="mt-11 pt-15vh w-full text-center flex flex-col justify-center">
      <BizBlockEmpty :title="config.texts.noRecord" />
    </div>
    <div v-else class="rr-page-body px-4">
      <div v-for="item in records" :key="item.orderId" class="rr-recharge-item">
        <div class="min-w-0">
          <h3 v-if="['SubscriptionDiscount', 'Subscription'].includes(item.rechargeType)" class="text-n-text-1 line-clamp-1">
            {{ `${item.rechargeType === 'SubscriptionDiscount' ? config.texts.discountedVip : config.texts.unlimitedVip} (${item.cycle})` }}
          </h3>
          <h3 v-else class="text-n-text-1 line-clamp-1">
            {{ item.coins }} {{ config.texts.coins }}
          </h3>
          <span class="text-12px text-n-text-3">{{ $d(new Date(item.rechargeTime), 'short') }}</span>
        </div>
        <div class="text-right pl-8px">
          <h3 class="text-n-text-1">
            {{ config.texts.rechargeTypeLabel(item.rechargeType) }}
          </h3>
          <span v-if="item.expireTime" class="text-12px text-n-text-3">{{ config.texts.expireOn }} {{ $d(new Date(item.expireTime), 'short') }}</span>
        </div>
      </div>
    </div>
    <div v-if="ending && records.length" class="py-15px text-13px text-n-text-3 text-center">
      {{ config.texts.noMore }}
    </div>
    <div v-else-if="fetching" class="py-15px flex items-center justify-center text-13px text-n-text-3">
      <div class="animate-spin">
        <i-icon-park-outline-loading />
      </div>
    </div>
  </div>
</template>

<style scoped>
.rr-page-body {
  padding-top: 2px;
}

.rr-recharge-item {
  margin-top: 10px;
  min-height: 76px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 14px;
  padding: 10px 12px;
  background: rgba(255, 255, 255, 0.02);
}
</style>
